export default {"src":"/login-app/[GIT_HASH]/_next/static/media/toggle_on.e30f3ba8.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};